import * as React from 'react'

import { Button, Text, TextSpinner } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { useDestroyShift } from 'modules/shift_management/hooks/useDestroyShifts'
import type { Shift } from 'modules/shift_management/lib/types'

interface Props {
  shift: Shift
  onClose: () => void
  isBackup?: boolean
}

const DeleteShiftModal = ({ shift, onClose, isBackup }: Props) => {
  const { onDestroy, submitting } = useDestroyShift({ shift, isBackup })

  const title = i18n.t('shift_management.actions.delete_shift_modal.title')
  const button = i18n.t('shift_management.actions.delete_shift_modal.confirm')
  const body = i18n.t('shift_management.actions.delete_shift_modal.prompt')

  return (
    <Modal
      illustration="delete-cross"
      title={title}
      description={
        <>
          {submitting && (
            <TextSpinner text={i18n.t('shift_management.actions.delete_shift_modal.spinner')} />
          )}
          {!submitting && <Text.Normal>{body}</Text.Normal>}
        </>
      }
      onSubmit={onDestroy}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button type="negative" disabled={submitting} submit>
            {button}
          </Button>
        </>
      }
    />
  )
}

export default observer(DeleteShiftModal)
